import { render, staticRenderFns } from "./StudentOverview.vue?vue&type=template&id=8c9c04e8&"
import script from "./StudentOverview.vue?vue&type=script&lang=ts&"
export * from "./StudentOverview.vue?vue&type=script&lang=ts&"
import style0 from "./StudentOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports